import { cn } from "@/lib/utils"

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      aria-hidden
      className={cn(
        "relative overflow-hidden rounded-md bg-skeleton",
        "before:absolute before:inset-0 before:translate-x-full before:animate-in before:bg-linear-to-r before:from-transparent before:via-card/60 before:to-transparent before:ease-standard before:animation-duration-loop before:repeat-infinite before:slide-in-from-left-[200%] motion-reduce:before:hidden",
        className,
      )}
      {...props}
    />
  )
}

export { Skeleton }
